export const MERCH_ADMIN_UIDS = [];

export function isMerchAdminUser({ user, profile }) {
  if (user?.uid && MERCH_ADMIN_UIDS.includes(user.uid)) return true;
  return profile?.username?.trim().toLowerCase() === "omeezzii";
}
